export default "__VITE_ASSET__BBtzSeSo__"